export default "__VITE_ASSET__1ef09661__"